import clsx from 'clsx'
import React from 'react'
import { selectDocumentLabel, usePackageStore } from 'stores/packageStore'
import { FlagAttribution } from '../FlagAttribution'
import { FlagItem } from '../FlagItem'

export default function FlagSummaryItem({ flag }) {
  const documentLabel = usePackageStore(selectDocumentLabel(
    flag.flaggable_type === 'PackageDocument' ? flag.flaggable_id : null
  ))

  return (
    <div className={clsx('flag-summary-item', flag.state === 'drafted' && 'flag-summary-item--drafted')}>
      {flag.flaggable_type === 'PackageDocument' && (
        <p className='dome-p3 dome-color-med-grey'>{documentLabel}</p>
      )}
      <FlagItem.Content flag={flag} />
      <FlagAttribution flag={flag} />
    </div>
  )
}
